import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./caLPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./caLdrawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



drawGrandTotal(doc, grandTotal);
  

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.DIVISIONTYPE ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          direct: 0,
          oncost: 0,
          grouptotal: 0,
        },
      };
    }

    const direct = Number(row["DIRECT LABOUR"] || 0);
    const oncost = Number(row["ACTUAL ON COST LABOUR"] || 0);

    groups[shop].rows.push(row);

    groups[shop].total.direct += direct;
    groups[shop].total.oncost += oncost;
    groups[shop].total.grouptotal += direct + oncost;

    return groups;
  }, {});
}